// Minimal ISO 3166-1 alpha-2 → lat/lng lookup (centroid capitals)
export const COUNTRY_COORDS = {
  US: [39.8, -98.6], GB: [55.3, -3.4], CA: [56.1, -106.3], MX: [23.6, -102.6],
  BR: [-14.2, -51.9], AR: [-38.4, -63.6], CL: [-35.7, -71.5], CO: [4.6, -74.3],
  PE: [-9.2, -75.0], VE: [6.4, -66.6], EC: [-1.8, -78.2], UY: [-32.5, -55.8],
  FR: [46.6, 2.2], DE: [51.2, 10.5], IT: [41.9, 12.6], ES: [40.5, -3.7],
  PT: [39.4, -8.2], NL: [52.1, 5.3], BE: [50.5, 4.5], CH: [46.8, 8.2],
  AT: [47.5, 14.5], SE: [60.1, 18.6], NO: [60.5, 8.5], FI: [61.9, 25.7],
  DK: [56.3, 9.5], IE: [53.4, -8.2], PL: [51.9, 19.1], CZ: [49.8, 15.5],
  SK: [48.7, 19.7], HU: [47.2, 19.5], RO: [45.9, 24.9], BG: [42.7, 25.5],
  GR: [39.1, 21.8], TR: [38.9, 35.2], UA: [48.4, 31.2], BY: [53.7, 27.9],
  RU: [61.5, 105.3], EE: [58.6, 25.0], LV: [56.9, 24.6], LT: [55.2, 23.9],
  IS: [64.9, -19.0], HR: [45.1, 15.2], SI: [46.2, 14.9], RS: [44.0, 21.0],
  BA: [43.9, 17.7], AL: [41.2, 20.2], MK: [41.6, 21.7], MT: [35.9, 14.4],
  CY: [35.1, 33.4], LU: [49.8, 6.1], AD: [42.5, 1.5], MC: [43.7, 7.4],
  IL: [31.0, 34.9], SA: [23.9, 45.1], AE: [23.4, 53.8], QA: [25.4, 51.2],
  KW: [29.3, 47.5], BH: [26.0, 50.6], OM: [21.5, 55.9], JO: [30.6, 36.2],
  LB: [33.9, 35.9], SY: [34.8, 38.9], IQ: [33.2, 43.7], IR: [32.4, 53.7],
  YE: [15.5, 48.5], EG: [26.8, 30.8], LY: [26.3, 17.2], TN: [33.9, 9.5],
  DZ: [28.0, 1.7], MA: [31.8, -7.1], SD: [12.9, 30.2], ET: [9.1, 40.5],
  KE: [-0.02, 37.9], TZ: [-6.4, 34.9], UG: [1.4, 32.3], NG: [9.1, 8.7],
  GH: [7.9, -1.0], SN: [14.5, -14.5], CI: [7.5, -5.5], CM: [7.4, 12.3],
  ZA: [-30.6, 22.9], ZW: [-19.0, 29.2], NA: [-22.9, 18.5], MZ: [-18.7, 35.5],
  AO: [-11.2, 17.9], DR: [7.9, -1.0], CD: [-4.0, 21.8], MG: [-18.8, 46.9],
  IN: [20.6, 78.9], PK: [30.4, 69.3], BD: [23.7, 90.4], LK: [7.9, 80.8],
  NP: [28.4, 84.1], AF: [33.9, 67.7], CN: [35.9, 104.2], JP: [36.2, 138.3],
  KR: [35.9, 127.8], KP: [40.3, 127.5], TW: [23.7, 121.0], HK: [22.4, 114.1],
  TH: [15.9, 100.9], VN: [14.1, 108.3], MY: [4.2, 101.9], SG: [1.4, 103.8],
  ID: [-0.8, 113.9], PH: [12.9, 121.8], MM: [21.9, 95.9], KH: [12.6, 104.9],
  LA: [19.9, 102.5], MN: [46.9, 103.8], KZ: [48.0, 66.9], UZ: [41.4, 64.6],
  AU: [-25.3, 133.8], NZ: [-40.9, 174.9], FJ: [-16.6, 179.4], PG: [-6.3, 143.9],
  CU: [21.5, -77.8], DO: [18.7, -70.2], HT: [18.9, -72.3], JM: [18.1, -77.3],
  PR: [18.2, -66.6], CR: [9.7, -83.8], PA: [8.5, -80.8], GT: [15.8, -90.2],
  HN: [15.2, -86.2], SV: [13.8, -88.9], NI: [12.9, -85.2], BO: [-16.3, -63.6],
  PY: [-23.4, -58.4], BS: [25.0, -77.4], BB: [13.2, -59.5], TT: [10.7, -61.2],
};

/** Given a country name, try to find a matching ISO code from the fetched country list */
export function findCoords(countryName, countriesList) {
  if (!countryName) return null;
  const c = countriesList.find(
    (x) => x.name.toLowerCase() === countryName.toLowerCase()
  );
  if (c && COUNTRY_COORDS[c.iso_3166_1]) return COUNTRY_COORDS[c.iso_3166_1];
  return null;
}
